import React, { useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import './Auth.css';

const EmailVerified: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const success = searchParams.get('success') === 'true';

  useEffect(() => {
    if (success) {
      // Auto-redirect to login after 5 seconds
      const timer = setTimeout(() => {
        navigate('/login', {
          state: {
            message: 'Email verified successfully! Please sign in to continue.'
          }
        });
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [success, navigate]);

  const handleLoginRedirect = () => {
    navigate('/login', {
      state: {
        message: 'Email verified successfully! Please sign in to continue.'
      }
    });
  };

  if (!success) {
    return (
      <div
        className="auth-container"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/background.jpg)`
        }}
      >
        <div className="auth-card">
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '48px', marginBottom: '20px' }}>❌</div>
            <h1>Verification Failed</h1>
            <p>There was an issue with your email verification.</p>

            <div style={{ marginTop: '30px' }}>
              <Link to="/resend-verification" className="btn btn-primary" style={{ marginRight: '10px' }}>
                Resend Verification
              </Link>
              <Link to="/login" className="btn btn-secondary">
                Back to Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="auth-container"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/background.jpg)`
      }}
    >
      <div className="auth-card">
        <div style={{ textAlign: 'center' }}>
          <div className="success-icon">✓</div>
          <h1>Email Verified!</h1>
          <p>Welcome to Debriefr. Your email has been successfully verified and your account is now active.</p>

          <div className="alert alert-success" style={{ margin: '20px 0' }}>
            <p><strong>Welcome to Debriefr!</strong></p>
            <p>Your account has been upgraded to the free tier. You can now access all basic features.</p>
          </div>

          <div style={{ marginTop: '30px' }}>
            <button
              onClick={handleLoginRedirect}
              className="btn btn-primary btn-full"
              style={{ marginBottom: '10px' }}
            >
              Continue to Sign In
            </button>
            <p><small>You will be redirected automatically in 5 seconds...</small></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailVerified;